<template>
  <div class="highchart-container">
    <highcharts class="runtime-chart" :options="runtimeGraphOptions" />
  </div>
</template>
<script>
import moment from 'moment';

import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import unitPreferencesMixin from '@shared/mixins/unitPreferencesMixin';

export default {
  name: 'HumidityGraph',
  mixins: [customerDetailMixin, unitPreferencesMixin],
  computed: {
    allDevices() {
      const allDevices = {};
      this.sensors.forEach((sensor) => {
        const {
          deviceId,
          uId,
          sensorType,
        } = sensor;
        const [selectedUid] = this.activeTZoneFilter.split('-');
        if (uId === selectedUid
          && (sensorType === 'A2TempHumidity' || sensorType === 'A2RoomTempHumidity')) {
          allDevices[deviceId] = {
            avgHumidity: [],
            minHumidity: [],
            maxHumidity: [],
          };
        }
      });
      return allDevices;
    },
    graphData() {
      const {
        partnerSettings: {
          DATE_FORMAT = 'MM-DD-YYYY',
        }
      } = this.$store.state.admin;

      const {
        allDevices,
      } = this;
      const columnDate = [];
      let maxHumidityLimit = -1;
      this.runtimeGraphData.sort((a,b) => new Date(a.localDate) - new Date(b.localDate)).forEach((c, idx) => {
        const {
          localDate,
          humidity,
        } = c;
        if (humidity) {
          Object.keys(humidity).forEach(((t) => {
            if (allDevices[t]) {
              const {
                avg,
                min,
                max,
              } = humidity[t];
              allDevices[t].avgHumidity.push(avg);
              allDevices[t].minHumidity.push(min);
              allDevices[t].maxHumidity.push(max);
              if (max > maxHumidityLimit) {
                maxHumidityLimit = max;
              }
            }
          }));
        }
        Object.keys(allDevices).forEach((key) => {
          if (allDevices[key].avgHumidity.length < idx + 1) {
            allDevices[key].avgHumidity.push(null);
          }
          if (allDevices[key].minHumidity.length < idx + 1) {
            allDevices[key].minHumidity.push(null);
          }
          if (allDevices[key].maxHumidity.length < idx + 1) {
            allDevices[key].maxHumidity.push(null);
          }
        });

        let date = moment(localDate).format('M/D/YYYY');
        if (DATE_FORMAT === 'DD-MM-YYYY') {
          date = moment(localDate).format('D/M/YYYY');
        }
        columnDate.push(date);
      });
      return {
        columnDate,
        allDevices,
        maxHumidityLimit,
      };
    },
    runtimeGraphOptions() {
      const {
        columnDate,
        allDevices,
        maxHumidityLimit,
      } = this.graphData;

      const {
        dateFormat
      } = this;

      const series = [];
      Object.keys(allDevices).forEach((key) => {
        const {
          avgHumidity,
          minHumidity,
          maxHumidity,
        } = allDevices[key];
        series.push({
          name: `Sensor-${key} Avg Humidity`,
          data: avgHumidity,
        });
        series.push({
          name: `Sensor-${key} Min Humidity`,
          data: minHumidity,
        });
        series.push({
          name: `Sensor-${key} Max Humidity`,
          data: maxHumidity,
        });
      });

      return {
        chart: {
          zoomType: 'x',
          height: 400,
          backgroundColor: '#0f1734',
        },
        credits: {
          enabled: false,
        },
        title: {
          text: 'Humidity',
          style: {
            color: 'white',
          },
        },
        tooltip: {
          useHTML: true,
          nullFormat: 'Value is not available.',
          formatter() {
            const s = this.series.name;
            if (s === ' ' && this.y === 0) {
              return 'No cycle Detection';
            }

            return `${this.x}<br/>`
              + `${this.series.name}: <b>${this.y}</b>`;
          },
        },
        xAxis: [{
          categories: columnDate,
          title: {
            text: 'Days',
            style: {
              color: 'white',
            },
          },
          labels: {
            formatter() {
              const label = this.value;
              const format = dateFormat;
              return moment(label)
                .format(format);
            },
            style: {
              color: 'white',
            },
          },
        }],
        yAxis: [
          {
            min: 0,
            max: maxHumidityLimit + 20,
            title: {
              text: 'Humidity',
              style: {
                color: 'white',
              },
            },
            stackLabels: {
              enabled: true,
              style: {
                fontWeight: 'bold',
                color: 'white',
              },
            },
            labels: {
              style: {
                color: 'white',
              },
            },
          },
        ],
        legend: {
          itemStyle: {
            color: 'white',
          },
          shadow: false,
          align: 'center',
          verticalAlign: 'bottom',
          x: 0,
          y: 0,
        },
        plotOptions: {
          column: {
            stacking: 'normal',
          },
        },
        series,
      };
    },
  },
};
</script>
